var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/slider-macros.j2"] = require( "macros/slider-macros.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/carousel-slider/carousel-zoom-image-arrows.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/slider-macros.j2", false, "product/templates/carousel-slider/carousel-zoom-image-arrows.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("create_slider_arrows")) {
var t_4 = t_1.create_slider_arrows;
} else {
cb(new Error("cannot import 'create_slider_arrows'")); return;
}
context.setVariable("create_slider_arrows", t_4);
output += "\n";
output += runtime.suppressValue((lineno = 1, colno = 21, runtime.callWrap(t_4, "create_slider_arrows", context, [runtime.makeKeywordArgs({"classPrefix": "shadow-zoom","arrowsOutside": false})])), env.opts.autoescape);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/carousel-slider/carousel-zoom-image-arrows.j2"] , dependencies)